import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  hasValidPersistedSession,
  readPersistedAdamsUser,
  resolveSessionInit,
  resolveSessionToken,
} from '../offline/offline-session-utils'

/**
 * Dopo reload PWA (pull-to-refresh) `location.state` è vuoto: ripristina /home
 * se la sessione è ancora valida in localStorage.
 */
export default function OfflineSessionBootstrap() {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const user = readPersistedAdamsUser()
    if (!hasValidPersistedSession(user)) return

    const path = location.pathname
    const isAuthEntry = path === '/' || path === '/login'
    if (!isAuthEntry) return

    navigate('/home', {
      replace: true,
      state: {
        token: user.token,
        init: user.init,
        lastLoginDate: user.lastLoginDate,
        isOfflineSession: user.isOfflineSession,
      },
    })
  }, [location.pathname, navigate])

  return null
}
